import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import $ from 'jquery';

import { editTextReset } from 'src/store/modules/editText';
import { buttonsReset } from 'src/store/modules/buttons';
import { imageReset, editCurrentIndex } from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/RadiusModalSlideTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import CountDown from 'src/components/CountDown';
import { getFontURL } from 'src/utils/getFontUrl';

let today = new Date();
const initViewValues = {
  currentIndex: 0,
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultIMAGE.webp'
    ]
  },
  radius: { multi_image: 0 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    multi_title: [
      'Weekly Top Seller 1',
      'Weekly Top Seller 2',
      'Weekly Top Seller 3'
    ],
    countdown_title: 'Time Left',
    multi_countdown: [
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      },
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      },
      {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        date: today.getDate() + 1,
        hour: 0,
        min: 0,
        sec: 0
      }
    ]
  },
  fontSize: { multi_title: 1.5, countdown_title: 0.875, multi_countdown: 1.75 },
  fontWeight: { multi_title: 500, countdown_title: 500, multi_countdown: 700 },
  color: {
    multi_title: '#ffffff',
    countdown_title: '#ffffff',
    multi_countdown: '#ffffff'
  },
  fontFamily: {
    multi_title: 'Montserrat',
    countdown_title: 'Montserrat',
    multi_countdown: 'Montserrat'
  },
  textAlign: {
    multi_title: 'left',
    countdown_title: 'right',
    multi_countdown: 'center'
  },

  btnText: { multi_button: ['Shop now 1', 'Shop now 2', 'Shop now 3'] },
  btnFontSize: { multi_button: 0.875 },
  btnFontWeight: { multi_button: 400 },
  btnColor: { multi_button: '#ffffff' },
  btnBgColorR: { multi_button: 0 },
  btnBgColorG: { multi_button: 0 },
  btnBgColorB: { multi_button: 0 },
  btnBgColorA: { multi_button: 0 },
  btnFontFamily: { multi_button: 'Montserrat' }
};

const RadiusModalSlide: FC = () => {
  const dispatch = useDispatch();
  const sliderRef = useRef<any>(null);
  const contentsSliderRef = useRef<any>(null);

  let templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiCountDownFontURL = getFontURL(fontFamily?.multi_countdown);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const multiButtonFontURL = getFontURL(btnFontFamily?.multi_button);

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url('${multiTitleFontURL}');
  }
  @font-face {
    font-family: 'multiCountdown';
    src: url('${multiCountDownFontURL}');
  }
  @font-face {
    font-family: 'countdownTitle';
    src: url('${countdownTitleFontURL}');
  }
  @font-face {
    font-family: 'multiButton';
    src: url('${multiButtonFontURL}');
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_view {
      width: 100%;
      height: 100%;

      position: relative;
      overflow: hidden;
      background: none;
    
      .background {
        width: 100%;
        height: 100%;

        position: absolute;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
      }
      .modal_wrapper {
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 1rem;
    
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    
        overflow: hidden;
        background-color: transparent;
      }

      .contents_wrapper {
        padding: 0 10%;
      }
      .contents_wrapper .title {
        width: 100%;
        height: 2.5rem;

        text-align: ${textAlign?.multi_title};
        color: ${color?.multi_title};
        font-size: ${fontSize?.multi_title}rem;
        font-weight: ${fontWeight?.multi_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.multi_title
          )
            ? fontFamily?.multi_title
            : 'multiTitle'
        };
      }

      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        width: 100%;
        height: 12.5rem;
      }
      
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        width: 15rem;
        height: 10rem;
        outline: none;
        border-radius: ${radius?.multi_image}px;
      }
      .slick_wrapper .slick-track img {
        object-flt: cover;
      }
      .slick_wrapper .slick-track {
        display: flex;
        margin-left: 10%;
      }
      .slick_wrapper .slick-track img {
        object-fit: cover;
      }

      .slick_wrapper .slick-slide {
        margin-right: 1rem;
      }
      .slick_wrapper .slick-list {
        margin-right: -1rem;
      }
      
      .timer_area {
        max-height: 1.5rem;
        margin-top: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #ffffff;
        font-size: 1.75rem;
        font-weight: 700;
        font-family: Montserrat;
      }

      .timer_area .countdown_text {
        max-height: 1.5rem;        
        display: flex;
        justify-content: start;
        align-items: center;
        color: #ffffff;
        font-size: 0.875rem;
        font-weight: 500;
        font-family: Montserrat;
      }
      .timer_area .timer {
        width: 10rem;
        height: 2rem;
        display: flex;
        
      }
      .timer_area li {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3rem;
        height: 2rem;                
      }
      .timer_area .en {
        display: flex;
        align-items: center;
        margin-left: 0.3rem;        
        height: 2rem;        
      
      }
      .timer_area .finish_ment {        
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        white-space: pre-line;
        font-size: 1rem;
      }

      .bottom_wrapper {
        width: 100%;
        height: 2rem;
        padding: 0 10%;

        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      .bottom_wrapper .bar {
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: start;
        align-items: center;
        text-align: left;
      }
      #bar_box {
        min-width: 7rem;
        max-width: 7rem;
        max-height: 0.125rem;
        min-height: 0.125rem;

        border-radius: 999px;
        background-color: #777777;
      }
      #bar_index {
        max-height: 0.125rem;
        min-height: 0.125rem;
        position: absolute;
        border-radius: 999px;
        background-color: #ffffff;
        transition: all ease 0.2s;
      }
      .bottom_wrapper .button {
        width: 100%;
        height: 100%;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        justify-content: end;
        align-items: center;
        text-align: right;

        color: ${btnColor?.multi_button};
        font-size: ${btnFontSize?.multi_button}rem;
        font-weight: ${btnFontWeight?.multi_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.multi_button
          )
            ? btnFontFamily?.multi_button
            : 'multiButton'
        };
        background-color: rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
      }

      .close_btn {
        text-align: center;
      }
      .close_btn button {
        width: 1.5rem;
        height: 1.5rem;
        margin-top: 2rem;
        
        font-size: 0;
        border: none;

        background-image: url(${closeImageUrl});
        background-repeat: no-repeat;
        background-size: 1.5rem;
        background-position: center;
        background-color: transparent;
      }
    }
  `;

  const settings = {
    arrows: false,
    infinite: false,
    dots: false,

    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    touchThreshold: 300
  };

  const contentsSettings = {
    arrows: false,
    infinite: false,
    fade: true,
    speed: 300,
    swipe: false
  };

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    // contentsSliderRef.current.slickGoTo(currentIndex);
    $('#bar_box').css('width', 7 + 'rem');
    $('#bar_index').css(
      'width',
      ((currentIndex + 1) / bgImage?.multi_image?.length) *
        (templateWidth > 767 ? 10 : 7) +
        'rem'
    );
  }, [bgImage?.multi_image, currentIndex]);

  useEffect(() => {
    sliderRef.current.slickGoTo(currentIndex);
    contentsSliderRef.current.slickGoTo(currentIndex);
  }, [currentIndex]);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="modal_wrapper">
          <div className="contents_wrapper">
            <Slider {...contentsSettings} ref={contentsSliderRef}>
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx} className="title">
                    {changeEnter(text?.multi_title?.[idx])}
                  </div>
                );
              })}
            </Slider>
          </div>
          <div className="slick_wrapper">
            <Slider
              {...settings}
              ref={sliderRef}
              afterChange={index => {
                dispatch(editCurrentIndex(index));
              }}
            >
              {text?.multi_title?.map((data: any, idx: number) => {
                return (
                  <div key={idx}>
                    <img
                      className="image"
                      src={bgImage?.multi_image?.[idx]}
                      alt="modal paging slide"
                    />

                    <div className="timer_area">
                      <p className="countdown_text">
                        {changeEnter(text?.countdown_title)}
                      </p>
                      <CountDown
                        key={idx}
                        time={text?.multi_countdown?.[idx]}
                      />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
          <div>
            <div className="bottom_wrapper">
              <div className="bar">
                {bgImage?.multi_image?.length !== 1 && (
                  <>
                    <div id="bar_box"></div>
                    <div id="bar_index"></div>
                  </>
                )}
              </div>

              <div className="button">
                {btnText?.multi_button?.[currentIndex]}
              </div>
            </div>
            <div className="close_btn">
              <button>close</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadiusModalSlide;
